import { NoticeBlock } from "@/components/NoticeBlock.tsx";
import { billingAccountLink } from "@/modules/billing/links.ts";
import { ContactSupportButton } from "@/modules/support/ContactSupportButton.tsx";
import { Trans } from "@lingui/react/macro";
import { Link } from "@tanstack/react-router";

export function SuspendedNotice({ billing_account_id }: { billing_account_id: number }) {
    return (
        <NoticeBlock icon="jp-warning-icon" button={<ContactSupportButton />}>
            <Trans>
                One of your billing accounts has a problem and your buckets have been suspended. See{" "}
                <Link className="underline" {...billingAccountLink({ id: billing_account_id })}>
                    billing account details
                </Link>{" "}
                for more information or contact support to resolve the issue.
            </Trans>
        </NoticeBlock>
    );
}
